module.exports = __webpack_public_path__ + "img/foam_ear_plugs.16943074.jpg";